import { render, staticRenderFns } from "./CopilotAgentChat.vue?vue&type=template&id=65325812&scoped=true"
import script from "./CopilotAgentChat.vue?vue&type=script&lang=js"
export * from "./CopilotAgentChat.vue?vue&type=script&lang=js"
import style0 from "./CopilotAgentChat.vue?vue&type=style&index=0&id=65325812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65325812",
  null
  
)

export default component.exports